export const STARS_RATING_COLOR = {
  FILL: "#DBDA1F",
  EMPTY: "#D9D9D9"
};
